import React, { createContext, useState, useContext } from 'react';

const MaintenanceModeContext = createContext();

export const MaintenanceModeProvider = ({ children }) => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(JSON.parse(localStorage.getItem("maintenanceMode")) ?? false);

  const setMaintenanceMode = (value) => {
    setIsMaintenanceMode(value);
  };

  return (
    <MaintenanceModeContext.Provider value={{ isMaintenanceMode, setMaintenanceMode }}>
      {children}
    </MaintenanceModeContext.Provider>
  );
};

export const useMaintenanceMode = () => {
  return useContext(MaintenanceModeContext);
};